// src/context/ViewportContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
//import { useOcxoData } from '../hooks/useOcxoData';

const ViewportContext = createContext();

export const ViewportProvider = ({ children }) => {
    //const { actions } = useOcxoData();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    
    //correspond value to the store
    //actions.setIsMobileOcxoCharts(isMobile);
    
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return (
    <ViewportContext.Provider value={{ isMobile }}>
      {children}
    </ViewportContext.Provider>
  );
};

export const useViewport = () => {
  const context = useContext(ViewportContext);
  if (!context) {
    throw new Error('useViewport must be used within a ViewportProvider');
  }
  return context;
};